import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/typeSlice";
import { typesSelector } from "slices/typeSlice";
import { removeMultipleTypes } from "slices/typeSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { fetchTypesListPage } from "slices/typeSlice";
import { Link } from "react-router-dom";
import { usePermissions } from "layouts/Admin";
const apiService = new Api();

function ClientType() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions()
  const { typesListPage: types, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(typesSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });


  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchTypesListPage(page));
  }, [])
  React.useEffect(() => {
    dispatch(fetchTypesListPage())
  }, [])

  const handleAddTypePopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchTypesListPage())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleRemoveItems = React.useCallback(() => {
    dispatch(removeMultipleTypes({ ids: selectedItems }, submitCallback))
  }, [selectedItems])

  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(types.map((type) => type.id.toString()))
  }



  const renderTableHeader = React.useCallback(() => {



    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchTypesListPage(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }

    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Client Account') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th>
          <TableHeaderItem
            title="Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Email"
            sortBy="email"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Phone"
            sortBy="phone"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Facilities"
            sortBy="facilities"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Departments"
            sortBy="departments"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Invoicing Period"
            sortBy="invoicing_period"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Client Account') &&
          <th>Status</th>
        }
        {checkPermission('Edit Client Account') &&
          <th>Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, types])


  const renderTableContent = React.useCallback(() => {
    return (
      types?.map((type, index) => {
        return <TypeItem type={type} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddTypePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      })
    )
  }, [types, selectedItems, current_page]);

  const handleClose = React.useCallback(() => {
    // refAddutton.current.click();
    setAddForm({ show: false })
  }, [])


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  return (
    <ListLayout
      heading="Client Accounts"
      time={true}
      title=""
      buttonTitle="Add Account"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchTypesListPage}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddLink={(callback) => checkPermission('Add Client Account') && <Link to="/clients/accounts/create" className="main_button ml-4">{'Add Account'}</Link>}
      addformModal={false}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddTypePopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      sortConfig={sortConfig}
      loader={loader}
      searchPlaceholder="Search accounts..."
      noOfItems={total}
      disableBootstrap={true}
    >
      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}

const TypeItem = ({
  type, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(type?.status == "active" ? 1 : 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  React.useEffect(() => {
    setStatus(type?.status == "active" ? 1 : 0 || 0)

  }, [type])
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Client Account') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={type.id} checked={selectedItems.includes(type.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.email || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.phone || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.facilities.map((val) => val.abbreviation).join(", ") || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.departments.map((val) => val.name).join(", ") || 'N/A'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {type?.invoicing_period || "N/A"}
      </td>
      {/* <td style={getBackgroundStyle(status)}>
        {type?.dynamic_fields?.length > 0 ?
          type?.dynamic_fields?.map((field) => (
            <>
              <p>{field?.name}</p>
              <br />
            </>
          ))
          : 'N/A'
        }
      </td> */}
      <td style={getBackgroundStyle(status)}>
        {type?.created_at || 'N/A'}
      </td>
      {checkPermission('Status Client Account') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(type?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Client Account') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <Link to={`/clients/accounts/update/${type?.id}`} className="table_edit">Edit</Link>
          </div>
        </td>
      }
    </tr>
  )
}

export default ClientType;